var map = {
	"./404.svg": "c0bf",
	"./bug.svg": "4817",
	"./chart.svg": "a422",
	"./clipboard.svg": "ed4a",
	"./component.svg": "eef6",
	"./dashboard.svg": "0fb5",
	"./documentation.svg": "93f8",
	"./drag.svg": "2765",
	"./edit.svg": "1c05",
	"./education.svg": "d485",
	"./email.svg": "d1f8",
	"./example.svg": "50f5",
	"./excel.svg": "a04e",
	"./exit-fullscreen.svg": "5265",
	"./exit.svg": "880e",
	"./eye-open.svg": "b607",
	"./eye.svg": "a5bf",
	"./form.svg": "78cf",
	"./fullscreen.svg": "9b18",
	"./guide.svg": "7837",
	"./icon.svg": "e9d7",
	"./international.svg": "0c24",
	"./language.svg": "a23e",
	"./link.svg": "0ac3",
	"./list.svg": "2fad",
	"./lock.svg": "ee36",
	"./message.svg": "4941",
	"./money.svg": "7c5f",
	"./nested.svg": "bf23",
	"./password.svg": "f5e3",
	"./pdf.svg": "6635",
	"./people.svg": "d4f7",
	"./peoples.svg": "26de",
	"./qq.svg": "723f",
	"./s-ing.svg": "5a79",
	"./s-over.svg": "26ea",
	"./s-success.svg": "9abd",
	"./s-waite.svg": "fb0e",
	"./search.svg": "f312",
	"./shopping.svg": "ef30",
	"./size.svg": "cd7a",
	"./skill.svg": "151b",
	"./star.svg": "a69a",
	"./tab.svg": "d115",
	"./table.svg": "eb61",
	"./theme.svg": "ebf6",
	"./tree-table.svg": "9842",
	"./tree.svg": "537d",
	"./user.svg": "56d0",
	"./wechat.svg": "c741",
	"./zip.svg": "ed5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7cfe";